import React, { Component } from 'react';

class Previous extends Component {



    render() {
        return (
            <>
                <h2 id='previous'>How we did this before</h2>
               
                <a href="https://fumeng-yang.github.io/CMSC471-Spring25/" target='_blank'>Spring 2025</a>

            </>
        )
    }
}



export default Previous;